import { updateCustomerProfile } from 'api/user/customer_requests';
import Button from 'components/base/Button';
import dayjs from 'dayjs';
import { getNumbersInRange } from 'helpers/utils';
import { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import { updateProfileDetails } from 'redux-state/user/customerSlice';

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

const EcomVerndorDetailInfo = ({ vendorId }: { vendorId?: string }) => {
  const dispatch = useDispatch();
  const customerDetails = useSelector(
    (state: RootState) => state.user.customer
  );

  const [submitting, setSubmitting] = useState(false);
  const [dob, setDob] = useState({
    day: customerDetails?.dob
      ? new Date(customerDetails.dob).getDate()
      : new Date().getDate(),
    month: customerDetails?.dob
      ? new Date(customerDetails.dob).getMonth()
      : new Date().getMonth(),
    year: customerDetails?.dob
      ? new Date(customerDetails.dob).getFullYear()
      : new Date().getFullYear()
  });
  const [gender, setGender] = useState(customerDetails?.gender || '');
  const [phone, setPhone] = useState(customerDetails?.phone || '');
  const [alternatePhone, setAlternatePhone] = useState(
    customerDetails?.alternatePhone || ''
  );

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);

    const dateOfBirth = new Date(dob.year ?? 0, dob.month ?? 0, dob.day ?? 0);
    const profile = {
      dob: dateOfBirth,
      gender,
      phone,
      alternatePhone
    };

    await updateCustomerProfile(profile).then(res => {
      toast.success('Profile updated successfully');
      dispatch(updateProfileDetails(profile));
      setSubmitting(false);
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Row className="gx-3 gy-4 mb-5">
        <Col xs={12} lg={6}>
          <Row className="g-2 gy-lg-0">
            <Col xs={12}>
              <h5 className="text-body-highlight mb-2"> Date of birth</h5>
            </Col>
            <Col xs={6} sm={2} lg={3} xl={2}>
              <Form.Select
                value={dob.day}
                onChange={e =>
                  setDob({ ...dob, day: parseInt(e.target.value) })
                }
              >
                {Array.from(Array(30).keys()).map(date => (
                  <option value={date} key={date}>
                    {date + 1}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col xs={6} sm={2} lg={3} xl={2}>
              <Form.Select
                value={months[dob.month ?? 0]}
                onChange={e => {
                  setDob({
                    ...dob,
                    month: months.indexOf(e.target.value)
                  });
                }}
              >
                {dayjs.months().map(month => (
                  <option value={month} key={month}>
                    {month.slice(0, 3)}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col xs={12} sm={8} lg={6} xl={8}>
              <Form.Select
                value={dob.year}
                onChange={e =>
                  setDob({ ...dob, year: parseInt(e.target.value) })
                }
              >
                {getNumbersInRange(1990, 2023).map(year => (
                  <option value={year} key={year}>
                    {year}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Row>
        </Col>
        <Col xs={12} lg={6}>
          <h5 className="text-body-highlight mb-2">Gender</h5>
          <Form.Select value={gender} onChange={e => setGender(e.target.value)}>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Prefer not to say</option>
          </Form.Select>
        </Col>
        <Col xs={12} lg={6}>
          <h5 className="text-body-highlight mb-2">Phone</h5>
          <Form.Control
            type="text"
            placeholder="Enter your phone number"
            value={phone}
            onChange={e => setPhone(e.target.value)}
          />
        </Col>
        <Col xs={12} lg={6}>
          <h5 className="text-body-highlight mb-2">Alternative phone</h5>
          <Form.Control
            type="text"
            placeholder="Enter your alternative phone number"
            value={alternatePhone}
            onChange={e => setAlternatePhone(e.target.value)}
          />
        </Col>
        {/* <Col xs={12} lg={4}>
          <h5 className="text-body-highlight mb-2">Facebook</h5>
          <Form.Control type="text" placeholder="Facebook" />
        </Col>
        <Col xs={12} lg={4}>
          <h5 className="text-body-highlight mb-2">Instagram</h5>
          <Form.Control type="text" placeholder="Instagram" />
        </Col>
        <Col xs={12} lg={4}>
          <h5 className="text-body-highlight mb-2">Twitter</h5>
          <Form.Control type="text" placeholder="Twitter" />
        </Col> */}
        <Col xs={12} className="text-end">
          <Button
            type="submit"
            variant="primary"
            className="px-7"
            disabled={submitting}
          >
            {submitting ? 'Saving...' : 'Save changes'}
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default EcomVerndorDetailInfo;
